import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FileActionToolbar from './FileActionToolbar';
import FileDisplay from './FileDisplay';
import FilePath from './FilePath';
import { DEFAULT_SUBSCRIPT_NUMBER } from '../../../constants';
import useFileManager from '../../../hooks/useFileManager';
import AlertMessage from '../../elements/alert-message/AlertMessage';

const FileManager = ({
  basePath,
  baseFolderChain,
  collection = null,
  subscript = DEFAULT_SUBSCRIPT_NUMBER,
}) => {
  const { t } = useTranslation();

  const {
    actions,
    changeFolder,
    error,
    fileList,
    folderChain,
    getFileList,
    loading,
    selectedFiles,
    selectFiles,
  } = useFileManager(basePath, baseFolderChain, collection, subscript);

  if (error)
    return (
      <AlertMessage
        severity="error"
        message={t('fileFetch', { ns: 'errors' })}
        action={getFileList}
      />
    );

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <FilePath folderChain={folderChain} onChangeFolder={changeFolder} />
      <FileActionToolbar
        actions={actions}
        fileCount={fileList.length || 0}
        loading={loading}
        selectedFiles={selectedFiles}
      />
      <FileDisplay
        fileList={fileList}
        folderChain={folderChain}
        onChangeFolder={changeFolder}
        loading={loading}
        selectedFiles={selectedFiles}
        selectFiles={selectFiles}
      />
    </Paper>
  );
};

FileManager.propTypes = {
  basePath: PropTypes.string.isRequired,
  baseFolderChain: PropTypes.array.isRequired,
  collection: PropTypes.string,
  subscript: PropTypes.string,
};

export default FileManager;
